<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <station-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></station-add-form>
                <station-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></station-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import StationAddForm from './forms/add/representations/WizardForm'
    import StationUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../stationStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            StationAddForm,
            StationUpdateForm
        },

    }
</script>
